var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex align-items-center@medium justify-content-center@until-medium flex-column@until-medium mt-prj2",
        },
        [
          _c(
            "a",
            {
              staticClass: "btn btn--dark w-100@until-medium w-auto@large",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.showModal.apply(null, arguments)
                },
              },
            },
            [_vm._v(_vm._s(_vm._f("translate")("versandaufteilungVornehmen")))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "pt-prj2@until-medium px-prj2@medium pt-0@medium text-small v-spacing-child-prj line-height-13",
            },
            [
              _c("VersandaufteilungIndicator", {
                attrs: {
                  auflageLeft: _vm.distribute,
                  addClassesForTextColor: false,
                  addresses: _vm.addresses,
                },
              }),
              _vm._v(" "),
              _vm.addresses.length
                ? _c("div", [
                    _vm._v(
                      "\n                " +
                        _vm._s(
                          _vm._f("translate")(
                            "versandaufteilungAdressen",
                            _vm.addresses.length
                          )
                        ) +
                        " (" +
                        _vm._s(
                          _vm._f("toCurrency")(
                            _vm.price,
                            _vm.globalConfig.shop.currency,
                            _vm.globalConfig.locale
                          )
                        ) +
                        ")\n            "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "FlyerlineModal",
        {
          ref: "modalRef",
          staticClass: "config-modal",
          attrs: { name: "versandaufteilung" },
          on: { close: _vm.handleClose },
        },
        [
          _c("div", { staticClass: "bg-white" }, [
            _c("h2", { staticClass: "h3 mt-0 mb-0" }, [
              _vm._v(_vm._s(_vm._f("translate")("txtVersandaufteilungTitle"))),
            ]),
            _vm._v(
              "\n      " +
                _vm._s(
                  _vm._f("translate")(
                    "versandaufteilungOverlayText",
                    _vm.formattedPrice
                  )
                ) +
                "\n      "
            ),
            _c(
              "div",
              {
                staticClass:
                  "px-prj2 py-prj px-3@large border mt-prj3 flex flex-column gap-2",
              },
              [
                _c(
                  "table",
                  {
                    staticClass: "w-full table--bordered",
                    style: `grid-template-columns: repeat(${
                      _vm.sortenData.length + 1
                    }, 1fr);`,
                  },
                  [
                    _c("thead", [
                      _c(
                        "tr",
                        [
                          _c("th"),
                          _vm._v(" "),
                          _vm._l(
                            _vm.sortenData.entries(),
                            function ([index, sorte]) {
                              return _c(
                                "th",
                                [
                                  _vm.sortenData.length === 1
                                    ? [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("translate")(
                                                "versandaufteilungAmountTitle"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.sortenData.length > 1
                                    ? [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(sorte.variantIdentifier) +
                                            "\n              "
                                        ),
                                      ]
                                    : _vm._e(),
                                  _vm._v(
                                    "\n              (" +
                                      _vm._s(sorte.num ?? 0) +
                                      " " +
                                      _vm._s(_vm._f("translate")("txtPieces")) +
                                      ")\n            "
                                  ),
                                ],
                                2
                              )
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(
                        _vm.addresses.entries(),
                        function ([addressIndex, address]) {
                          return _c(
                            "tr",
                            [
                              _c(
                                "td",
                                [
                                  _c("VersandaufteilungAdresse", {
                                    attrs: {
                                      address: address,
                                      addressService: _vm.addressService,
                                      canRemoveAddress: addressIndex !== 0,
                                      index: addressIndex,
                                      showAddressBook: _vm.user,
                                    },
                                  }),
                                  _vm._v(" "),
                                  _vm.pristine === false &&
                                  _vm.addressResults[addressIndex]?.okay ===
                                    false
                                    ? _c(
                                        "div",
                                        {
                                          staticClass: "text-error text-small",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.addressResults[addressIndex]
                                                  .message
                                              ) +
                                              "\n              "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(
                                _vm.sortenData.entries(),
                                function ([sortenIndex, sorte]) {
                                  return _c("td", [
                                    _c("input", {
                                      ref: "sortenAmountRefs",
                                      refInFor: true,
                                      staticClass: "text-center",
                                      attrs: { type: "number" },
                                      domProps: {
                                        value:
                                          address.variants?.[sortenIndex]
                                            ?.number ?? address.quantity,
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.updateAddressEntry(
                                            addressIndex
                                          )
                                        },
                                      },
                                    }),
                                  ])
                                }
                              ),
                            ],
                            2
                          )
                        }
                      ),
                      0
                    ),
                    _vm._v(" "),
                    _c("tfoot", [
                      _c(
                        "tr",
                        [
                          _c("td", [_vm._v("Total")]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.sortenData.entries(),
                            function ([_, sorte]) {
                              return _c("td", [
                                _vm._v(
                                  _vm._s(sorte.numAssigned ?? 0) +
                                    " " +
                                    _vm._s(_vm._f("translate")("txtPieces"))
                                ),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        [
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("translate")(
                                  "txtVersandaufteilungRemainingPieces"
                                )
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.sortenData.entries(),
                            function ([_, sorte]) {
                              return _c("td", [
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "text-error": sorte.missing !== 0,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(sorte.missing ?? 0) +
                                        " " +
                                        _vm._s(_vm._f("translate")("txtPieces"))
                                    ),
                                  ]
                                ),
                              ])
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-prj2" }, [
                  _c("div", { staticClass: "column" }, [
                    _c(
                      "a",
                      {
                        staticClass:
                          "btn btn--dark btn--prj-min-x w-100@until-medium",
                        on: {
                          click: function ($event) {
                            return _vm.versandaufteilungService.addEmptyAddress()
                          },
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticClass: "svg-icon mr-2",
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 38.98 38.98",
                            },
                          },
                          [
                            _c("circle", {
                              attrs: {
                                cx: "19.49",
                                cy: "19.49",
                                r: "18.49",
                                fill: "none",
                                stroke: "#fff",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                              },
                            }),
                            _c("path", {
                              attrs: {
                                d: "M3.51-3.89v14.8m-7.4-7.4h14.8",
                                transform: "translate(15.98 15.98)",
                                fill: "none",
                                stroke: "#fff",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                              },
                            }),
                          ]
                        ),
                        _vm._v(
                          "\n              " +
                            _vm._s(
                              _vm._f("translate")(
                                "versandaufteilungAddRecipient"
                              )
                            ) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "column small-12" }, [
                    _c("div", { staticClass: "bg-shade-light p-prj2" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex@medium align-items-center" },
                        [
                          _c("input", {
                            staticClass: "sr-only",
                            attrs: {
                              "aria-hidden": "true",
                              type: "file",
                              id: "addresses_fileupload",
                              accept:
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                              required: "",
                            },
                            on: {
                              change: function ($event) {
                                return _vm.uploadChanged($event)
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "label",
                            {
                              staticClass:
                                "btn btn--outline-dark w-100@until-medium bg-white label-aligned",
                              attrs: { for: "addresses_fileupload" },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  staticClass: "mr-2 svg-icon",
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    viewBox: "0 0 11.91 12.76",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M.75,12.76a1,1,0,0,1-.51-.28.85.85,0,0,1-.24-.6V9a.85.85,0,0,1,.82-.88.79.79,0,0,1,.37.07A.85.85,0,0,1,1.73,9v1.82c0,.14,0,.14.13.14h8.2c.13,0,.13,0,.13-.13V9.09a.86.86,0,0,1,.36-.75.86.86,0,0,1,1.36.58v2.91a.9.9,0,0,1-.24.66.94.94,0,0,1-.43.25h-.08Z",
                                      transform: "translate(0)",
                                      fill: "#3a3a39",
                                      "fill-rule": "evenodd",
                                    },
                                  }),
                                  _c("path", {
                                    attrs: {
                                      d: "M6,9.26H5.87A.9.9,0,0,1,5.41,9a.93.93,0,0,1-.21-.69V2.91L5.12,3c-.31.31-.62.61-.93.93a1.05,1.05,0,0,1-.85.35.87.87,0,0,1-.69-.49.8.8,0,0,1,.13-.85l1-1L5.41.26a.86.86,0,0,1,1.24,0l1.07,1L9.13,2.71a1.19,1.19,0,0,1,.35.47.86.86,0,0,1-1.41.89c-.31-.3-.61-.61-.91-.91L6.94,3V8.37a.83.83,0,0,1-.38.73l-.37.16Z",
                                      transform: "translate(0)",
                                      fill: "#3a3a39",
                                      "fill-rule": "evenodd",
                                    },
                                  }),
                                ]
                              ),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("translate")(
                                      "versandaufteilungUploadExcelFile"
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass:
                                "mb-0 pt-prj2 pt-0@medium px-prj2@medium p-prj2@large line-height-12",
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("translate")(
                                      "versandaufteilungUploadExceltxt1"
                                    )
                                  ) +
                                  "\n                  "
                              ),
                              _c(
                                "a",
                                {
                                  staticClass: "text-black font-weight-bold",
                                  attrs: {
                                    role: "button",
                                    title: _vm.globalConfig.excel_url,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.getExcelTemplate()
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("translate")(
                                        "versandaufteilungUploadExceltxt2"
                                      )
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm._f("translate")(
                                      "versandaufteilungUploadExceltxt3"
                                    )
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", [
                        _vm.fileNames
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "mt-prj2 pt-prj border-top border-shade-darker font-weight-bold",
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.fileNames) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isError
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "mt-prj text-error d-flex line-height-12",
                                attrs: { id: "addresses_fileupload_response" },
                              },
                              [
                                _c(
                                  "svg",
                                  {
                                    staticClass:
                                      "mr-2 svg-icon flex-child-fix position-relative t-1px",
                                    attrs: {
                                      xmlns: "http://www.w3.org/2000/svg",
                                      viewBox: "0 0 36 36",
                                    },
                                  },
                                  [
                                    _c("circle", {
                                      attrs: {
                                        cx: "18",
                                        cy: "18",
                                        r: "18",
                                        fill: "#e94d47",
                                      },
                                    }),
                                    _c("path", {
                                      attrs: {
                                        d: "M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z",
                                        fill: "#fff",
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm._f("translate")("txtErrorFileUpload")
                                    ) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]),
                    ]),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex flex-row justify-content-between mt-2" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn--outline btn--outline-dark",
                    on: {
                      click: function ($event) {
                        return _vm.close()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm._f("translate")("txtCancel")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    attrs: { disabled: !_vm.pristine && !_vm.isValid },
                    on: {
                      click: function ($event) {
                        return _vm.save()
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm._f("translate")("txtApply")))]
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("TextAddress", { ref: "textEditAddress" }),
          _vm._v(" "),
          _c("AddressBook", { ref: "addressbookEditAddress" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }